/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_TitleInputs */

const vi_carrier_form_title = /** @type {(inputs: Carrier_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo vận đơn Viettel Post`)
};

/**

* @param {Carrier_Form_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_title = /** @type {((inputs?: Carrier_Form_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_title(inputs)
});